import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb, FiMail } from 'react-icons/fi'
import { MdOutlineLocalPhone, MdOutlineStoreMallDirectory, MdOutlineWhatsapp } from 'react-icons/md'
import Layout from '../components/Layout/Layout'

const Contact = () => {
  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Contacto
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-2">
              Contacto
            </h1>
            <p className="text-xl font-normal font-body text-primary-text leading-relaxed">
              ¿Tienes dudas o deseas más información?
            </p>
            <p className="text-base font-light font-body text-primary-text leading-relaxed">
              Nuestro equipo está preparado para asesorarte y ayudarte a encontrar la pieza perfecta.<br />
              Contáctanos con confianza: con gusto te brindaremos la información que necesites o podrás agendar una cita para recibir una atención personalizada, exclusiva y llena de detalle.
            </p>
            <p className="text-sm font-light font-body text-primary-text mt-2">
              Horario de atención: Lunes a viernes de 8:00 a.m. a 11:00 a.m. y 12:00 p.m. a 5:00 p.m.<br />
              Sábados de 8:00 a.m. a 11:00 a.m. y 12:00 p.m. a 2:00 p.m.
            </p>
          </div>

          {/* Contact Information Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Email */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <FiMail className='w-6 h-6 text-rose-600' />
                </div>
                <div>
                  <h3 className="text-2xl font-title font-semibold text-primary-text mb-2">Correo electrónico</h3>
                  <p className="text-base text-primary-text font-body font-medium mb-2">contactocoronasarca@gmail.com</p>
                  <p className="text-base text-primary-text font-body font-normal">
                    Envíanos un correo para solicitar información detallada sobre nuestros productos, cotizaciones personalizadas o pedidos especiales. Nuestro equipo te responderá con la atención y el cuidado que caracterizan a nuestra marca.
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <MdOutlineLocalPhone className='w-6 h-6 text-indigo-600' />
                </div>
                <div>
                  <h3 className="text-2xl font-title font-semibold text-primary-text mb-2">Llamada telefónica</h3>
                  <p className="text-base text-primary-text font-body font-medium mb-2">Tel. +52 352 112 02 46</p>
                  <p className="text-base text-primary-text font-body font-normal">
                    Llámanos para consultar disponibilidad de modelos, tiempos de entrega o resolver cualquier duda sobre tu compra. Recibirás atención personalizada de nuestro equipo, siempre dispuesto a ayudarte a encontrar la pieza ideal.
                  </p>
                </div>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <MdOutlineWhatsapp className='w-6 h-6 text-green-600' />
                </div>
                <div>
                  <h3 className="text-2xl font-title font-semibold text-primary-text mb-2">WhatsApp</h3>
                  <p className="text-base text-primary-text font-body font-medium mb-2">Tel. +52 352 243 05 46</p>
                  <p className="text-base text-primary-text font-body font-normal">
                    Contáctanos directamente por WhatsApp para una atención rápida y personalizada. Podrás verificar existencias, solicitar fotografías adicionales, conocer precios actualizados o agendar una cita en tienda.
                  </p>
                </div>
              </div>
            </div>

            {/* Store Location */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <MdOutlineStoreMallDirectory className='w-6 h-6 text-cyan-600' />
                </div>
                <div>
                  <h3 className="text-2xl font-title font-semibold text-primary-text mb-2">Visita la tienda</h3>
                  <p className="text-base text-primary-text font-body font-medium mb-2">Cda. Zaragoza 52, Zona Nº 2 Capulines, 47940 La Ribera, Jal.</p>
                  <p className="text-base text-primary-text font-body font-normal">
                    Vive la experiencia completa, conoce nuestras piezas en persona, prueba modelos, toma medidas y recibe asesoría individualizada para elegir la corona o accesorio perfecto. Cada visita es una experiencia exclusiva, diseñada para ayudarte a brillar con estilo y confianza.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
          <div className="w-full h-96">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.8442123456789!2d-102.2793814!3d20.3484015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDIwJzU0LjIiTiAxMDLCsDE2JzQ1LjgiVw!5e0!3m2!1ses-419!2smx!4v1764611439232!5m2!1ses-419!2smx&markers=20.3484015,-102.2793814" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de la tienda - Cda. Zaragoza 52, Zona Nº 2 Capulines, La Ribera, Jal."
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Contact